<template>
  <div class="card-body px-2 bd-b py-3" v-if="totalAwards">
    <h3 class="mb-0 t-500 px-3">
      Scientific Awards <span class="t-secondary">{{ totalAwards }}</span>
      <i class="fa fa-trophy d-block pull-right t-placeholder"></i>
    </h3>
    <!-- Collapsed view, only show first researcher with first award -->
    <template v-if="totalAwards > 1 && collapsed">
      <div class="my-2">
        <div class="d-flex align-items-center my-3 px-3">
          <i class="t-lr fa fa-user t-secondary t-sm mr-2" />
          <router-link
            v-if="!isEmpty(sortedResearchers[0].researcher.slug_values)"
            :to="{
              name: 'researcher.show',
              params: { id: sortedResearchers[0].researcher.slug_values[0] },
              query: { fullName: stripTags(sortedResearchers[0].researcher.full_name) }
            }"
          >
            {{ sortedResearchers[0].researcher.full_name }}
          </router-link>
          <span v-else>{{sortedResearchers[0].researcher.full_name}}</span>
        </div>
        <award :award="sortedResearchers[0].scientific_awards.find(a => a.name)" />
      </div>
    </template>
    <!-- Show everything/uncollapsed -->
    <template v-else>
      <div v-for="(data, index) in sortedResearchers" :key="`${index}-${data.researcher.full_name}`" class="my-2">
        <div class="d-flex align-items-center my-3 px-3">
          <i class="t-lr fa fa-user t-secondary t-sm mr-2" />
          <router-link
            v-if="!isEmpty(data.researcher.slug_values)"
            :to="{
              name: 'researcher.show',
              params: { id: data.researcher.slug_values[0] },
              query: { fullName: stripTags(data.researcher.full_name) }
            }"
          >
            {{ data.researcher.full_name }}
          </router-link>
          <span v-else>{{data.researcher.full_name}}</span>
        </div>
        <award v-for="(award, index) in data.scientific_awards" :key="index" :award="award" />
      </div>
    </template>
    <a
      v-if="totalAwards > 1"
      @click.prevent="collapsed = !collapsed"
      class="px-3 t-sm"
      href="#"
    >Show {{ collapsed ? 'all' : 'less' }}</a>
  </div>
</template>

<script>
import Award from '@/components/shared/scientificAwards/Award'

export default {
  name: 'scientificAwardsResearchGroup',
  props: {
    researchers: {
      type: Array,
      required: true
    }
  },
  components: {
    Award
  },
  data () {
    return {
      collapsed: true
    }
  },
  computed: {
    sortedResearchers () {
      const filteredResearchers = this.researchers.filter(data => {
        return data.researcher && data.scientific_awards.length > 0
      }).sort((a, b) => {
        return b.scientific_awards.length - a.scientific_awards.length
      })
      return filteredResearchers
    },
    totalAwards () {
      return this.sortedResearchers.reduce(
        (prev, cur) => {
          if (!cur.scientific_awards) return prev
          return prev + cur.scientific_awards.length
        },
        0
      )
    }
  }
}
</script>
